import { render, staticRenderFns } from "./CustomerAndVehicleForm.vue?vue&type=template&id=36061518&lang=pug"
import script from "./CustomerAndVehicleForm.vue?vue&type=script&lang=js"
export * from "./CustomerAndVehicleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports